import React from 'react'
import Footer from '../footer/Footer'
import Header from '../header/Header'

function Contact() {
  return (
    <>
        <Header />
        <div className='product'>
        <h1 className='exampleForRooting'>Contact</h1>
        </div>
        <Footer />
    </>
  )
}

export default Contact